import { useEffect, useState } from 'react'
import { TopManufacturerDepartment } from '@/network/graphql.g'
import { genderCategoryMap } from '@/components/organisms/toolbar/desktop/campaignNavigationLinks'
import { lastVisitedMainCategoryKey } from './useCurrentMainCategoryId'

const departmentByCategoryId: Record<string, TopManufacturerDepartment> = {
  [genderCategoryMap.women]: TopManufacturerDepartment.Women,
  [genderCategoryMap.men]: TopManufacturerDepartment.Men,
  [genderCategoryMap.children]: TopManufacturerDepartment.Children
}

const useTopManufacturerDepartment = (): TopManufacturerDepartment => {
  const [department, setDepartment] = useState<TopManufacturerDepartment>(
    TopManufacturerDepartment.All
  )

  useEffect(() => {
    try {
      const categoryId = localStorage.getItem(lastVisitedMainCategoryKey)
      setDepartment(
        departmentByCategoryId[categoryId] ?? TopManufacturerDepartment.All
      )
    } catch {
      return
    }
  }, [])

  return department
}

export default useTopManufacturerDepartment
